import React, { memo } from 'react'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { Button } from 'transfix-ui'
import { CarrierComplianceText } from './CarrierComplianceText'

const useCarrierComplianceStyles = makeStyles(theme => ({
  card: {
    backgroundColor: brandColors.coolGray1,
    padding: theme.spacing(3),
  },
}))

interface ICarrierComplianceProps {
  onClickBid: () => void
}

export const CarrierCompliance = memo<ICarrierComplianceProps>(({ onClickBid }) => {
  const { trackEvent } = useFMSAnalytics()
  const { setActiveShipmentDetailsId, shipmentDetails: shipment } = useMarketplaceContext()
  const { id: shipmentId } = shipment || {}
  const classes = useCarrierComplianceStyles()

  const clickBidHandler = () => {
    trackEvent('Rate Con', 'BID_RATE_CONFIRMATION', { shipmentId })
    setActiveShipmentDetailsId(shipmentId)
    onClickBid()
  }

  return (
    <Box className={classes.card}>
      <Typography variant='subtitle1'>Compliance check required</Typography>
      <CarrierComplianceText />
      <Box pt={3}>
        <Button color='primary' onClick={clickBidHandler} size='large'>
          Submit a Bid to Continue
        </Button>
      </Box>
    </Box>
  )
})
